export default class Attachment {
	constructor(name, file, url, attachment_type) {
		this._id = '' + Math.random();
		this.name = name;
		this.file = file;
		this.url = url;
		this.attachment_type = attachment_type;
		this.metadata = {};
	}
}

export const AttachmentName = Object.freeze({
	svg: 'svg',
	vsdx: 'vsdx'
});

export const AttachmentType = Object.freeze({
	svg: 'svg',
	vsdx: 'vsdx',
	json: 'json'
});
